import { createReducer } from 'redux-create-reducer';
import callAPI from '../../../utils/callAPI';

// Upload File
export const REQUEST_UPLOAD_FILE = 'REQUEST_UPLOAD_FILE';
export const REQUEST_UPLOAD_FILE_SUCCESS = 'REQUEST_UPLOAD_FILE_SUCCESS';
export const REQUEST_UPLOAD_FILE_FAILURE = 'REQUEST_UPLOAD_FILE_FAILURE';
export const RESET_UPLOAD_FILE = 'RESET_UPLOAD_FILE';

const defaultState = {
  imageUrl: null,

  // upload file
  uploadingFile: false,
  uploadFileSuccess: false,
  uploadFileFailure: false,
};

const reducer = createReducer(defaultState, {
  [REQUEST_UPLOAD_FILE]: (state, _action) => ({
    ...state,
    uploadingFile: true,
    uploadFileSuccess: false,
    uploadFileFailure: false,
  }),
  [REQUEST_UPLOAD_FILE_SUCCESS]: (state, action) => ({
    ...state,
    imageUrl: action?.payload?.data?.url,
    uploadingFile: false,
    uploadFileSuccess: true,
    uploadFileFailure: false,
  }),
  [REQUEST_UPLOAD_FILE_FAILURE]: (state) => ({
    ...state,
    uploadingFile: false,
    uploadFileSuccess: false,
    uploadFileFailure: true,
  }),
  [RESET_UPLOAD_FILE]: (state) => ({
    ...state,
    imageUrl: null,
    uploadingFile: false,
    uploadFileSuccess: false,
    uploadFileFailure: false,
  }),
});

export default reducer;
export const namespace = 'uploadFile';

export const uploadFileAPI = (formData) => async (dispatch, getState) => {
  return await callAPI({
    method: 'post',
    apiPath: '/upload',
    actionTypes: [REQUEST_UPLOAD_FILE, REQUEST_UPLOAD_FILE_SUCCESS, REQUEST_UPLOAD_FILE_FAILURE],
    variables: formData,
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    dispatch,
    getState,
  });
};

export const resetUploadFile = () => ({
  type: RESET_UPLOAD_FILE,
});
